import autoTable from "jspdf-autotable";
import { ADDITIONAL_TAX_SERVICES, ADDITIONAL_TAX_SERVICES_HEADER, IOSS_TIER_FEES } from "./taxdesk-pdf-data";
import { formatDate } from "GlobalShared/helpers/dateHelper";
import { COLOR_BLACK, COLOR_DARK_GRAY, COLOR_LIGHT_GRAY, COLOR_WHITE, iossSection, MAIN_WEBSITE, ossSection, PRIVACY_POLICY, vatSection } from "./pdf-common";
import { PdfContext } from "./PdfContext";
const header = (ctx) => {
  if (ctx.model.withImages) {
    ctx.doc.addImage(ctx.model.logoUrl, "PNG", ctx.pageCenter - 7.5, 3, 15, 14);
  }
};
const footer = (ctx, pageNumber) => {
  ctx.doc.text(`Page ${pageNumber}`, ctx.sideMargin, ctx.footerY);
  ctx.doc.text(`Indirect Tax Services`, ctx.pageWidth - ctx.sideMargin - 2, ctx.footerY, { align: "right" });
};
const firstPage = (ctx) => {
  header(ctx);
  let yCurrent = ctx.topStart;
  yCurrent += 4;
  ctx.textCentered("Engagement contract for Core Tax Compliance Services and Additional Tax Services", yCurrent, {
    size: 11,
    isBold: true
  });
  yCurrent += 13;
  const userInfoGap = 10;
  ctx.text("Full legal name of the contracting party", ctx.sideMargin, yCurrent, { isBold: true });
  yCurrent += userInfoGap;
  ctx.text("Legal status of the contracting party", ctx.sideMargin, yCurrent, { isBold: true });
  yCurrent += userInfoGap;
  ctx.text("Registered address of the contracting party", ctx.sideMargin, yCurrent, { isBold: true });
  yCurrent += userInfoGap;
  ctx.text("VAT Number", ctx.sideMargin, yCurrent, { isBold: true });
  yCurrent += userInfoGap;
  ctx.text("Signature", ctx.sideMargin, yCurrent, { isBold: true });
  ctx.horizontalLine(ctx.sideMargin + 19, ctx.pageCenter - 10, yCurrent + 1);
  yCurrent += userInfoGap;
  ctx.text("Date", ctx.sideMargin, yCurrent, { isBold: true });
  ctx.doc.text(ctx.model.contractDate ? formatDate(ctx.model.contractDate) : "", ctx.sideMargin + 40, yCurrent);
  ctx.horizontalLine(ctx.sideMargin + 19, ctx.pageCenter - 10, yCurrent + 1);
  yCurrent += userInfoGap + 3;
  ctx.text("I hereby accept this contract on behalf of Tax International Services:", ctx.sideMargin + 10, yCurrent, {
    isBold: true
  });
  yCurrent += 4;
  if (ctx.model.withImages) {
    ctx.doc.addImage(ctx.model.signatureUrl, "PNG", ctx.pageCenter + 40, yCurrent - 18, 39, 18);
  }
  ctx.horizontalLine(ctx.pageCenter + 40, ctx.pageCenter + 80, yCurrent);
  yCurrent += 4;
  ctx.text("Nick Aston", ctx.pageCenter + 55, yCurrent, { isBold: true });
  yCurrent += 4;
  ctx.doc.text("Managing Director", ctx.pageCenter + 50, yCurrent);
  yCurrent = ctx.topStart + 17;
  ctx.text(ctx.model.partnerName ? ctx.model.partnerName : "", ctx.pageCenter, yCurrent);
  yCurrent += userInfoGap;
  ctx.text(ctx.model.legalStatus ? ctx.model.legalStatus : "", ctx.pageCenter, yCurrent);
  yCurrent += userInfoGap;
  ctx.doc.text(ctx.model.addressLine ? ctx.model.addressLine : "", ctx.pageCenter, yCurrent, {
    maxWidth: 80,
    lineHeightFactor: 1.2
  });
  yCurrent += userInfoGap;
  ctx.text(ctx.model.vatNumber ? ctx.model.vatNumber : "", ctx.pageCenter, yCurrent);
  const startOfText = 127;
  yCurrent = startOfText - 8;
  ctx.doc.setLineHeightFactor(16);
  ctx.horizontalLine(ctx.sideMargin, ctx.pageWidth - ctx.sideMargin, yCurrent);
  ctx.doc.setLineHeightFactor(1.4);
  const gap = ctx.textGap;
  const lineHeight = ctx.textLineHeight;
  yCurrent = startOfText;
  ctx.text(`General`, ctx.sideMargin, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextFirst(
    1,
    "This engagement contract governs the services that Tax Desk International Services Ltd, D\xF3zsa Gy\xF6rgy \xFAt 84/B., 1068 Budapest, Hungary, trading as Tax Desk (\u201CTax Desk\u201D or \u201Cwe\u201D) will provide to the contracting party indicated above (\u201Cyou\u201D).",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.numberedTextFirst(
    2,
    "Upon entering into this contract, you agree that Tax Desk will provide the Core Tax Compliance Services set out in paragraph 6 below in respect of the countries listed and for the Core Tax Compliance Services Fee set out in",
    yCurrent
  );
  ctx.appendixLink("Appendix 1.", 6, ctx.sideMargin + 46, yCurrent + 13.5);
  yCurrent += lineHeight * 4 + gap;
  ctx.numberedTextFirst(3, "In addition, upon your specific request, Tax Desk may provide you with Additional Tax Services for Additional Services Fee, which are set out in", yCurrent);
  ctx.appendixLink("Appendix 2.", 7, ctx.sideMargin + 26, yCurrent + 9);
  yCurrent += lineHeight * 3 + gap;
  ctx.numberedTextFirst(4, "Whenever the contract refers to working days, it is understood as working days in Hungary.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.numberedTextFirst(
    5,
    "Tax Desk has a process of acceptance of new clients, which includes background verification and the assessment of our compliance with applicable Tax Desk and regulatory requirements. Tax Desk\u2019s acceptance of this contract is subject to the satisfactory completion of Tax Desk\u2019s pre-approval procedures and compliance with relevant Anti-Money Laundering Law.",
    yCurrent
  );
  yCurrent += lineHeight * 6 + gap;
  ctx.text("Our services", ctx.sideMargin, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextFirst(6, "Core Tax Compliance Services include the following services:", yCurrent);
  yCurrent += lineHeight + gap;
  ctx.bulletedTextFirst("Provide access to the Tax Desk Portal", yCurrent);
  ctx.linkWithBrackets(MAIN_WEBSITE, ctx.firstBulletedX + ctx.indent + 49, yCurrent, ctx.bulletedTextWidth);
  yCurrent += lineHeight + gap;
  ctx.bulletedTextFirst(
    "Arrange the selected VAT registration (country specific VAT registration, EU One-Stop-Shop (OSS) VAT registration or EU Import-One-Stop-Shop (IOSS) VAT registration) on your behalf, unless you already possess the relevant VAT registration number. Tax Desk is not responsible for any delays and penalties caused by you (e.g. retrospective registration, delay in document provision, not correct documents provided) or by the tax authorities during the registration process.",
    yCurrent
  );
  yCurrent = startOfText + 6;
  ctx.bulletedTextSecond(
    "If the VAT registration or the takeover of your VAT registration is rejected by the tax authorities because of you (e.g. delay in document or information provision, incorrect or incomplete document or information provision) we reserve the right to charge you \u20AC150 per hour to redo the process.",
    yCurrent,
    true
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.bulletedTextSecond(
    "If required by law, appoint a fiscal representative (for country specific VAT registration) or a VAT intermediary (for EU IOSS VAT registration) on your behalf for the required VAT registration. Tax Desk may use a subcontractor for the role of the fiscal representative or the VAT intermediary. You will be required to sign a separate agreement with the appointed fiscal representative or VAT intermediary.",
    yCurrent
  );
  yCurrent += lineHeight * 7 + gap;
  ctx.bulletedTextSecond(
    "Prepare the VAT returns, EC Sales and/or Purchase Lists, VAT local listings and SAF-T files (where required) for approval by you before submission. Tax Desk will prepare these returns based on data that you upload to the Tax Desk Portal in the required format. Where the necessary data is received according to the deadline set out in paragraph 11 and there are no additional queries on the data, Tax Desk will provide the draft returns to you at least 3 working days prior to the statutory submission deadline. For EU IOSS registration where VAT payments are required to be made via the VAT intermediary and not directly to the relevant Tax Authorities, we will provide the draft returns to you at least 7 working days prior to the statutory submission deadline. This paragraph does not apply if the timespan between the deadline set out in paragraph 11 and the statutory submission deadline is equal to or lower than 4 working days. In such cases, Tax Desk will undertake the best efforts to provide the draft returns to you as soon as possible.",
    yCurrent
  );
  yCurrent += lineHeight * 18 + gap;
  ctx.bulletedTextSecond("Submit returns to the appropriate tax authority where legally possible and confirm submission to you.", yCurrent);
  footer(ctx, 1);
};
const secondPage = (ctx) => {
  ctx.doc.addPage();
  header(ctx);
  const gap = ctx.textGap;
  const lineHeight = ctx.textLineHeight;
  let yCurrent = ctx.topStart;
  ctx.bulletedTextFirst("Provide payment instructions via email (i.e. cover letter) or via the Tax Desk Portal to you regarding your VAT liabilities.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.bulletedTextFirst(
    "Act as your correspondence address for the tax authority where legally permitted during the contract duration; and inform you of any action related to your VAT reporting and liabilities as per the correspondence received from the tax authority. If you require additional information connected to the correspondence received from the tax authority, we can charge you \u20AC150 per hour for gathering the information requested by you.",
    yCurrent
  );
  yCurrent += lineHeight * 8 + gap;
  ctx.bulletedTextFirst(
    "In case of contract termination, Tax Desk will not prepare and/or submit tax returns for tax reporting periods where the filing deadline falls after the termination date (as per paragraphs 28-33) or inform you about actions required because of tax authorities\u2019 correspondence.",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.numberedTextFirst(
    7,
    "For the avoidance of doubt, the following services are not included in the scope of the Core Tax Compliance Services, although they can be provided as Additional Tax Services upon payment of the respective Additional Services Fee:",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.bulletedTextFirst(
    "Carrying out sworn translation or legalisation of documents that are required to obtain the VAT registration numbers in each country. Tax Desk may arrange for a third party to perform sworn translations on your behalf and charge the service fees, including admin fee to you.",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.bulletedTextFirst("Preparing and submitting VAT and associated returns for tax reporting periods which ended before the date of this contract.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.bulletedTextFirst("Reviewing invoices and confirming that they meet the required regulatory requirements.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.bulletedTextFirst("Preparing your VAT returns (or any other return) based on data which is not provided in the correct format, unless specifically agreed with you.", yCurrent);
  yCurrent += lineHeight * 3 + gap;
  ctx.bulletedTextFirst("Auditing or verifying the correctness and completeness of the data you provide to us.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.numberedTextFirst(
    8,
    "Should we or you believe that there is a need to consult with a specialist indirect tax adviser before answering specific tax authority questions, we can arrange for a Tax Desk affiliate in the relevant country to provide advice to you. Such assistance will be subject to a separate fee to be advised by the other Tax Desk affiliate. Depending on the nature of the advice, we can engage the Tax Desk affiliate as a subcontractor, or you can enter into a separate contract with the Tax Desk affiliate directly.",
    yCurrent
  );
  yCurrent += lineHeight * 8 + gap;
  ctx.text(`Your obligations`, ctx.sideMargin, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextFirst(
    9,
    "Tax Desk shall not accept any liability for errors arising from incomplete information or inaccuracies in the data provided to us. Tax Desk will not verify the data provided by you.",
    yCurrent
  );
  yCurrent += lineHeight * 3 + gap;
  ctx.numberedTextFirst(
    10,
    "In order for us to prepare your VAT, EU OSS and associated returns (based on the requirements of the given country: e.g. EC Sales and Purchase Lists, Local listings and SAF-T files), you must provide us either with the Amazon VAT Transactions Report (typically downloaded from your Amazon Seller Central account) in text format without modification or the correct Tax Desk VAT/OSS data template files available on the Tax Desk Portal once you have subscribed to our services. For EU IOSS returns you must provide the standard Tax Desk IOSS data template available on the Tax Desk Portal.",
    yCurrent
  );
  yCurrent = ctx.topStart;
  ctx.numberedTextSecond(
    void 0,
    "The Tax Desk Portal has been tailored to process these specific data reports and requires these fixed formats. If you modify the data before uploading it to the Tax Desk Portal, you do so at your own risk.",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.numberedTextSecond(
    11,
    "You must provide us with all required data to prepare the VAT, EU OSS, EU IOSS and associated returns for each calendar month by 17:00 Central European Time (\u201CCET\u201D) on the 6th calendar day following the end of the calendar month to be reported. If you do not use filing extension in Germany (The filing deadline from the 10th of the following month subsequent to the reporting period can be extended with one month if a prepayment is made to the tax authorities. The prepayment amounts to 1/11 of the expected VAT debt for the respective year and is due at the time the application is filed), the source data must be provided to us by 4th calendar day following the end of the calendar month. If data is received late, we reserve the right to charge you a penalty fee of \u20AC50 per occurrence of your default/delay.",
    yCurrent
  );
  yCurrent += lineHeight * 13 + gap;
  ctx.numberedTextSecond(
    12,
    "If no data is received by the statutory submission deadline for a particular return and you have not instructed us to submit nil returns, Tax Desk may reserve the right not to submit a return to the tax authority for the particular period, unless it is in your or our interest that a nil return should be submitted. This may result in financial or other consequences from the tax authority, for which you will be fully liable. Tax Desk shall not be held liable for any financial or other consequences if your return was not submitted according to this paragraph.",
    yCurrent
  );
  yCurrent += lineHeight * 9 + gap;
  ctx.numberedTextSecond(
    13,
    "In case you are trading on multiple platforms (for example, several marketplaces and/or through your own website), you must provide Tax Desk with the data needed to prepare the VAT returns in a format specified by Tax Desk (Tax Desk template files).",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.numberedTextSecond(
    14,
    "We will ask you to approve each return prior to us submitting it to the relevant tax authority. If we do not receive your explicit approval (or alternative instruction) by 17:00 CET on the approval deadline, we will assume that you agree with our calculations and that Tax Desk should submit the return to the tax authority, where permitted to do so. We reserve the right to charge you a separate fee for correcting a return that was submitted according to this. If you have failed to make the VAT payment to the fiscal representative, the VAT intermediary or the Tax Authorities on time, a nil return or no return may be submitted. Tax Desk and the fiscal representative or the VAT intermediary shall not be held liable for any financial or other consequences if your return was not submitted according to this paragraph.",
    yCurrent
  );
  yCurrent += lineHeight * 13 + gap;
  ctx.numberedTextSecond(
    15,
    "In some countries, Tax Desk or its subcontractor is not authorised to file returns on behalf of another person or entity. In these cases, it will be your responsibility to sign the returns and submit them directly to the tax authority. Tax Desk will provide you with the return to be submitted together with the postal address where it should be sent or advise on e-filing option if available. You will be responsible for ensuring that the return is delivered.",
    yCurrent
  );
  yCurrent += lineHeight * 7 + gap;
  ctx.numberedTextSecond(
    16,
    "Notwithstanding paragraph 17, Tax Desk will not make VAT payments on your behalf. We will provide you with the necessary payment instructions but the responsibility to make the payments will remain with you and you must make sure that the payment of VAT due has cleared to the given bank account by the deadline.",
    yCurrent
  );
  footer(ctx, 2);
};
const thirdPage = (ctx) => {
  ctx.doc.addPage();
  header(ctx);
  const gap = ctx.textGap;
  const lineHeight = ctx.textLineHeight;
  let yCurrent = ctx.topStart;
  ctx.numberedTextFirst(
    17,
    "For Spain, you need a SEPA compatible EUR bank account, and you will make VAT payments directly to the Spanish Tax Authority using this account. You cannot use any third-party payment companies, the SEPA compatible EUR bank account must be owned by you. The VAT amount can be paid only after submission of your VAT return; therefore, it is crucial that you pay attention and approve the return by the approval deadline. After your VAT return has been submitted, we will inform you that you can initiate the payment, telling you the amount due, payment reference, bank account where you need to transfer the VAT amount. When submitting your return, we will add the details of your SEPA compatible EUR bank account. The Spanish Tax Authority will accept the VAT payment only from this account. If you try to pay from a different bank account, your payment may be rejected which will lead to late payment and associated penalties. Tax Desk cannot accept liability for such cases or their consequences. You must settle the payment before the payment deadline.",
    yCurrent
  );
  yCurrent += lineHeight * 18 + gap;
  ctx.numberedTextFirst(
    void 0,
    "If you do not have a SEPA compatible EUR bank account, then we can facilitate the payment for you as an extra service for a separate charge (EUR 30 per transfer). In this scenario you will be paying the VAT amount to a Tax Desk EUR account, and we will forward your payment to the Spanish Tax Authority. We must receive the full amount of VAT due (after any bank fees and similar charges) so that it is received as cleared funds in our account at least 3 working days before the payment deadline. You will be sent an e-mail from Tax Desk requesting payment after your return has been submitted. You must follow the e-mail instructions because the payment has to be made to the correct account, in the right currency, using the right payment reference as per our instructions. If the amount is received late or with insufficient funds or with an incorrect reference number, Tax Desk and our partners cannot guarantee the timely payment of VAT to the Tax Authorities. Late VAT payment may have consequences and penalties that Tax Desk does not accept liability for.",
    yCurrent
  );
  yCurrent += lineHeight * 18.1 + gap;
  ctx.numberedTextFirst(void 0, "If you need to pay penalty in Spain, we will charge you \u20AC150 per hour to assist you in the payment process.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.numberedTextFirst(
    18,
    "For the IOSS compliance where the corresponding VAT payment due (if there is one) must be paid via your VAT intermediary, the VAT payment must be received as cleared funds in the required currency by the appointed VAT intermediary at the latest by 10:00 CET, 3 (three) working days before the due payment deadline in order for the payment to be made by the payment deadline. Should you wish to transfer the payment in a currency other than the required currency then you can if you wish to arrange an FX conversion through the VAT intermediary and will need to agree to the VAT intermediary\u2019s specific terms and conditions in respect of this service.",
    yCurrent
  );
  yCurrent = ctx.topStart;
  ctx.numberedTextSecond(
    19,
    "You shall retain responsibility for the correctness and completeness of all returns and other filings we submit on your behalf, and for the payment of your tax liabilities. In particular, Tax Desk is not responsible for the accuracy of the data reported in the annual tax return, if the preliminary returns were prepared and submitted by another service provider, nor are we in the position to reconcile the annual filing with the preliminary returns.",
    yCurrent
  );
  yCurrent += lineHeight * 8 + gap;
  ctx.numberedTextSecond(
    20,
    "Tax Desk shall not accept any responsibility for penalties and other surcharges imposed by tax authorities if returns are submitted late due to the late delivery of data to us or if you pay your VAT liabilities late. Tax Desk\u2019s liability should be limited to the amount set in paragraph 34 of the engagement contract. In any case, we shall not be liable for your loss resulting from interest amount due on the VAT liability that was not settled in time with the respective tax authorities.",
    yCurrent
  );
  yCurrent += lineHeight * 8 + gap;
  ctx.numberedTextSecond(
    21,
    "You shall send to us promptly any notices, assessments or determinations received by tax authorities regarding your VAT returns prepared by Tax Desk for the service period covered by this agreement. If you receive any notices, assessments or determination that refer to service periods handled by Tax Desk, and you have appointed a new service provider to represent you in VAT matters, we may provide you an explanation or a summary of the letter received, but we may not be able to take any action on your behalf which includes contacting the tax authorities, since you are represented by another service provider.",
    yCurrent
  );
  yCurrent += lineHeight * 10 + gap;
  ctx.numberedTextSecond(
    22,
    "You shall retain responsibility for maintaining records and associated papers concerning your tax affairs in accordance with legal requirements in the country of your VAT/IOSS registrations and your country of establishment.",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.numberedTextSecond(
    23,
    "You shall provide a bank guarantee for the fiscal representative or the tax authorities if required (instructions will be provided by Tax Desk) which should be valid for the full period during which Tax Desk is providing services to you. We will confirm to you by writing once the bank guarantee is received either by the fiscal representative or the tax authorities.",
    yCurrent
  );
  yCurrent += lineHeight * 6 + gap;
  ctx.text(`Payment for services`, ctx.secondNumberedX, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextSecond(
    24,
    "All Core Tax Compliance Services Fees must be paid in advance as you are instructed during the signup process or the registration and compliance process through bank transfer or any other means accepted on either the Tax Desk Portal or the VAT intermediary\u2019s system.",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.numberedTextSecond(
    25,
    "Where you request us to provide Additional Tax Services, we will seek your approval for the estimated fees and disbursements in advance that should be provided before we start the respective service.",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.numberedTextSecond(
    26,
    "Tax Desk will issue an invoice electronically and send it to your email address as recorded in your account on the Tax Desk Portal or make it available on the Tax Portal after payment of the respective fees. Tax Desk shall have no obligation to provide services if payment is not received in advance.",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.numberedTextSecond(27, "All fees are exclusive of VAT (where applicable) and any non- Hungarian taxes payable thereon or deductible therefrom and may be revised in the future.", yCurrent);
  footer(ctx, 3);
};
const fourthPage = (ctx) => {
  ctx.doc.addPage();
  header(ctx);
  const gap = ctx.textGap;
  const lineHeight = ctx.textLineHeight;
  let yCurrent = ctx.topStart;
  ctx.text(`Termination`, ctx.firstNumberedX, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextFirst(
    28,
    "Either party has the right to terminate this contract by providing 30 days written notice to info@taxdesk.com (if cancelled by you) or to the designated contact email address as recorded on your account on the Tax Desk Portal (if cancelled by Tax Desk). If you do so:",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.bulletedTextFirst("The termination date of the contract will be the 30th day after the written notice was given to Tax Desk.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.bulletedTextFirst(
    "Within the first 14 calendar days from the date of payment of the Core Tax Compliance Services Fee, you will be eligible for a proportionate refund of the fees paid as set out in Section 31 below, minus \u20AC200 administration fee to cover costs already incurred by Tax Desk.",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.bulletedTextFirst("After the first 14 calendar days, no refund of the Core Tax Compliance Services Fee will be paid.", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.numberedTextFirst(
    29,
    "Tax Desk may be required to terminate this contract for legal, regulatory or professional reasons. In these circumstances, the contract may be cancelled by Tax Desk immediately and we shall not be required to carry out any further work following the termination, nor shall we be responsible or liable for any consequences arising from such termination.",
    yCurrent
  );
  yCurrent += lineHeight * 6 + gap;
  ctx.numberedTextFirst(
    30,
    "Termination with immediate effect by Tax Desk. Tax Desk or your appointed fiscal representative/VAT intermediary will notify you by sending an email to your email address as recorded in your account on the Tax Desk Portal, if you fail to upload data or make VAT payment within the appropriate deadline. If you do not rectify the failure within 5 working days after the notification, Tax Desk reserves the right to terminate this contract with immediate effect.",
    yCurrent
  );
  yCurrent += lineHeight * 8 + gap;
  ctx.numberedTextFirst(
    void 0,
    "Tax Desk notes that it is not possible to submit an IOSS return retrospectively after the deadline. Therefore, we reserve the right to terminate our contract immediately if a correct IOSS return cannot be submitted before the deadline because you have not uploaded the data or made the VAT payment before the deadlines specified in paragraph 11 and paragraph 18 respectively. We can also terminate the contract immediately if you refrain from cooperation with the tax authorities during the tax audit or another similar proceedings. In these circumstances, the contract may be cancelled immediately. We shall not be required to carry out any further work following the termination, nor shall we be responsible or liable for any consequences arising from such termination.",
    yCurrent
  );
  yCurrent += lineHeight * 13 + gap;
  ctx.numberedTextFirst(
    31,
    "Tax Desk may terminate this agreement with immediate effect if the Core Tax Compliance Services Fees have not been paid according to paragraph 24 and this breach is not remedied withing 2 business days after the receipt of Tax Desk\u2019s notice. This contract may be terminated by Tax Desk with immediate effect if you do not renew the Core Tax Compliance Services after the 12 month period has lapsed or the included package\u2019s credit has been fully utilized.",
    yCurrent
  );
  yCurrent += lineHeight * 8 + gap;
  ctx.numberedTextFirst(
    32,
    "If Tax Desk cancels this contract due to a material breach committed by you (such as the breaches mentioned in paragraph 30), no refund will be made of the Core Tax Compliance Services Fee. In case of cancellation by Tax Desk for any other reason, a refund of the Core Tax Compliance Services Fee will be paid prorata according to the number of completed months of services or the number of packages utilized, whichever is smaller.",
    yCurrent
  );
  yCurrent = ctx.topStart;
  ctx.numberedTextSecond(
    33,
    "If you are required to provide a bank guarantee and this is not provided or is cancelled, Tax Desk is entitled to stop providing services immediately and no Core Tax Compliance Services Fee will be repaid.",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.text(`Limitation of liability`, ctx.secondNumberedX, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextSecond(
    34,
    "By signing this contract, the signatory parties of this contract mutually agree that Tax Desk\u2019s liability to you in connection with the services provided shall be limited, on the basis set out in Appendix 1 and Appendix 2, to a maximum of 1,5 times the Service Fee of the respective country or service.",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.numberedTextSecond(35, "Any claims are to be submitted in an eighteen-month limitation period that commences", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.bulletedTextSecond("upon the delivery of the Services where Services have been delivered,", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.bulletedTextSecond("upon the date of termination when the Services Contract has been terminated,", yCurrent);
  yCurrent += lineHeight * 2 + gap;
  ctx.bulletedTextSecond(
    "upon the date on which an unauthorized disclosure took place when the loss or damage is suffered as a result of, arising from or in connection with our unauthorized disclosure of Confidential Information.",
    yCurrent
  );
  yCurrent += lineHeight * 4 + gap;
  ctx.numberedTextSecond(
    void 0,
    "You shall be required to inform us of any claim within the shortest time permitted by the prevailing circumstances. You shall be liable for any damage that results from late notification. Such eighteen-month limitation period shall be preclusive (i.e. you lose your rights upon expiry of that period).",
    yCurrent
  );
  yCurrent += lineHeight * 5 + gap;
  ctx.text(`Data Privacy`, ctx.secondNumberedX, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextSecond(
    36,
    "The services defined under this contract require us to collect and process your personal data and act as data processor. The website below contains our privacy statements and explains the way how we process your data and ensure appropriate security levels:",
    yCurrent
  );
  yCurrent += lineHeight * 4;
  ctx.linkWithBrackets(PRIVACY_POLICY, ctx.secondNumberedX + ctx.indent, yCurrent, ctx.numberedTextWidth);
  yCurrent += lineHeight + gap;
  ctx.text(`The Engagement Contract`, ctx.secondNumberedX, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextSecond(
    37,
    "The Engagement Contract sets out the entire agreement and understanding between us in connection with the services and supersedes any prior agreements, understandings, arrangements, statements or representations (unless made fraudulently) relating to the services. The contract may be accepted via the Tax Desk portal with online acceptance, and unless you request, Tax Desk will not prepare a signed copy of it, but the electronic version will guide the relationship. Any modifications or variations to the Engagement Contract shall be concluded with the same formalities as described above.",
    yCurrent
  );
  yCurrent += lineHeight * 10 + gap;
  ctx.text(`Applicable law`, ctx.secondNumberedX, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextSecond(
    38,
    "The Engagement Contract shall be subject to and governed by Hungarian law. The Civil Code of Hungary (and any subsequent amendment or re-enactment thereof) currently in effect will apply to all questions not regulated in the Engagement Contract.",
    yCurrent
  );
  footer(ctx, 4);
};
const fifthPage = (ctx) => {
  ctx.doc.addPage();
  header(ctx);
  const gap = ctx.textGap;
  const lineHeight = ctx.textLineHeight;
  let yCurrent = ctx.topStart;
  ctx.text(`Confidential Information`, ctx.firstNumberedX, yCurrent, { isBold: true });
  yCurrent += lineHeight + gap;
  ctx.numberedTextFirst(
    39,
    "We may acquire sensitive, confidential information concerning your business or affairs in the course of delivering the Services (\u201CConfidential Information\u201D). In relation to Confidential Information we shall comply with the confidentiality restrictions imposed on us by any authority in Hungary with whose requirements we are bound to comply, as well as any obligations imposed on us by the Hungarian law. We are obliged to comply with any requirement of Hungarian law and professional standards or with any resolution of any authority applicable onto us with whose requirements we are bound to comply to disclose Confidential Information. While complying with the rules of relating to the confidentiality, obligation and the treatment of confidential information, we may share information relating to you, to our relationship with you, and to the Services, including Confidential Information, privately and in confidence, with our Infrastructure Providers (including but not limited to email, cloud and/or AI services providers we may use from time to time) with agents and/or external legal advisers, in each case who are required to implement safeguards to protect confidentiality, in order to facilitate the administration of our business or to support the maintenance of quality, independence and standards in our work. We shall remain responsible for confidentiality if Confidential Information is shared with agents, and/or external legal advisers, or accessed by our Infrastructure Provider. We may remove, or arrange for the removal of, names and any other identifiers from Confidential Information and then use such anonymised information for lawful purposes chosen at our discretion. This clause shall not apply where Confidential Information properly enters the public domain. This clause shall not prohibit our disclosure of Confidential Information where we wish to disclose it to our professional indemnity insurers or advisers, in which event we may do so in confidence only.",
    yCurrent
  );
  footer(ctx, 5);
};
const appendix1Page = (ctx) => {
  ctx.doc.addPage();
  header(ctx);
  ctx.text("Appendix 1", ctx.sideMargin, ctx.topStart, { isBold: true, size: 11 });
  ctx.text(`Tax Desk will provide the following Core Tax Compliance Services and the Core Tax Compliance Services Fee will apply:`, ctx.sideMargin, ctx.topStart + 7);
  const hasIossService = ctx.model.iossTier !== void 0;
  const hasVatService = ctx.model.hasVatService;
  const hasEuOssVat = ctx.model.hasEuOssVat;
  const availableServices = [].concat(hasVatService ? [vatSection] : []).concat(hasEuOssVat ? [ossSection] : []).concat(hasIossService ? [iossSection] : []);
  const top = {
    val: ctx.topMargin + 21
  };
  availableServices.forEach((service, index) => {
    const sectionLetter = String.fromCharCode("a".charCodeAt(0) + index);
    service(sectionLetter, top, ctx, IOSS_TIER_FEES);
  });
  footer(ctx, 6);
};
const appendix2Page = (ctx) => {
  ctx.doc.addPage();
  header(ctx);
  ctx.text("Appendix 2: Additional Tax Services", ctx.sideMargin, ctx.topStart, { isBold: true, size: 11 });
  ctx.text(`The following Additional Tax Services may be provided upon your explicit request:`, ctx.sideMargin, ctx.topStart + 5);
  autoTable(ctx.doc, {
    head: ADDITIONAL_TAX_SERVICES_HEADER,
    body: ADDITIONAL_TAX_SERVICES,
    theme: "grid",
    startY: ctx.topStart + 7,
    styles: {
      textColor: COLOR_BLACK,
      overflow: "linebreak",
      font: "times",
      fontSize: 8,
      lineColor: COLOR_LIGHT_GRAY,
      valign: "middle",
      cellPadding: { top: 1, bottom: 1, horizontal: 1 }
    },
    headStyles: {
      fillColor: COLOR_DARK_GRAY,
      textColor: COLOR_WHITE
    },
    columnStyles: {
      0: { cellWidth: 45 },
      1: { cellWidth: 135 }
    },
    didParseCell: (_data) => {
    }
  });
  footer(ctx, 7);
};
const generate = (ctx) => {
  firstPage(ctx);
  secondPage(ctx);
  thirdPage(ctx);
  fourthPage(ctx);
  fifthPage(ctx);
  appendix1Page(ctx);
  appendix2Page(ctx);
};
export const generateTaxDeskPDF = (pdfModel) => {
  const ctx = new PdfContext(pdfModel);
  generate(ctx);
  ctx.doc.save(`Contract_${pdfModel.partnerName}_${pdfModel.contractReference}.pdf`);
  return ctx.doc.output("blob");
};
export const generateTaxDeskPDFForTest = (pdfModel, filePath) => {
  const ctx = new PdfContext(pdfModel);
  generate(ctx);
  ctx.doc.save(filePath);
};
